namespace nscs.input {
    export class InputTextField extends Phaser.GameObjects.Container {

        pokemonNameDiv: HTMLDivElement = null;
        inputTextField: HTMLInputElement = null;

        inputTextFieldWidth: number = 160;
        inputTextFieldHeight: number = 30;
        inputTextFieldFontSize: number = 13;
        inputTextFieldPosition: object = {x: 0, y: 0};

        constructor(scene: Phaser.Scene) {
            super(scene);

            this.pokemonNameDiv = (<HTMLDivElement>document.querySelector('#pamNameDiv'));
            this.inputTextField = (<HTMLInputElement>document.querySelector('#pamInputId'));
        }

        public initializeInput(): void {
            this.setInputTextFieldContainerVisible(true);

            this.adjustInput();
            this.scene.game.scale.addListener(Phaser.Scale.Events.RESIZE, this.adjustInput);
        }

        public adjustInput:()=>void = ()=> {
            let globalPos = toGlobal(this, this.inputTextFieldPosition);
            const px:string = 'px';
            let pr: number = 1;//this.scene.game.device.os.desktop ? 1 : Math.min(this.scene.game.device.os.pixelRatio, 3);

            this.inputTextField.style.width = Math.ceil(this.inputTextFieldWidth / pr / this.scene.game.scale.displayScale.x) + px;
            this.inputTextField.style.height = this.inputTextFieldHeight + px;
            this.inputTextField.style.fontSize = this.inputTextFieldFontSize / this.scene.game.scale.displayScale.y + px;

            let mt:number = parseInt(this.scene.game.canvas.style.marginTop.split(px)[0]);
            let ml:number = parseInt(game.canvas.style.marginLeft.split(px)[0]);
            this.pokemonNameDiv.style.marginTop = (mt + Math.ceil(globalPos.y / pr / this.scene.game.scale.displayScale.y) - this.inputTextFieldHeight/2) + px;
            this.pokemonNameDiv.style.marginLeft = (ml + Math.ceil(globalPos.x / pr / this.scene.game.scale.displayScale.x)) + px;
        };

        public destroyInput(): void {
            this.setInputTextFieldContainerVisible(false);
            this.scene.game.scale.removeListener(Phaser.Scale.Events.RESIZE, this.adjustInput);
        }

        public setInputTextFieldContainerVisible(visible:boolean):void {
            (<HTMLDivElement>document.querySelector('.inputContainer')).style.display = visible ? 'block' : 'none';
            if (visible) {
                this.inputTextField.focus();
            }
        }

        public getText():string {
            return this.inputTextField.value;
        }

        public setText(text:string):void {
            this.inputTextField.value = text;
        }
    }
}